import { LocationEnterIcon } from './LocationEnterIcon';

/**
 * author: Michael Richins
 * id 2D8B2899-C765-48CF-9AEA-64327CB14542
 * name location-enter
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/location-enter.svg
 * tags
 * - Home Automation 
 */
export const PresenceEnterIcon = LocationEnterIcon;
export default PresenceEnterIcon